import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex overflow-hidden items-center gap-2" }

import { useCompanyProfile } from '@/account';
import {
	CallShortMessage,
	ConversationCallMessage
} from '@/inbox/composition';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CallShortMessage',
  props: {
    message: null,
    isUnread: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	message: CallShortMessage | ConversationCallMessage;
	isUnread: boolean;
};



function formatCallDuration() {
	const duration = props.message.content.call_duration;
	const minutes = Math.floor((duration / 60) % 60);
	const seconds = duration % 60;

	let message = '';

	if (minutes) {
		message += minutes.toString().endsWith('1')
			? `${minutes} minute `
			: `${minutes} minutes `;
	}

	if (seconds) {
		message += seconds.toString().endsWith('1')
			? `${seconds} second `
			: `${seconds} seconds `;
	}

	return message;
}

const isOutbound = computed(() => {
	return props.message.content?.direction === 'outgoing';
});

function getCallMessage() {
	const { userId } = useCompanyProfile();
	const { status, records } = props.message.content;
	const { sender } = props.message;

	const senderName =
		(sender?.id === userId.value
			? 'you'
			: sender?.name) || 'you';

	if (records?.[0]?.type === 'voicemail') {
		return `Voicemail${
			records[0]?.transcriptionText
				? ': ' + records[0]?.transcriptionText
				: ''
		}`;
	}

	if (status === 'no-answer' || status === 'missed') {
		return isOutbound.value
			? `Missed call from ${senderName}. No one answered.`
			: `You missed inbound call.`;
	}

	if (status === 'busy' || status === 'redirected') {
		return isOutbound.value
			? `Missed call from ${senderName}. Busy.`
			: `You missed inbound call.`;
	}

	if (status === 'hangup') {
		return isOutbound.value
			? `Missed call from ${senderName}. Hangup.`
			: `You missed inbound call.`;
	}

	if (status === 'in-progress') {
		return `On call with ${senderName}`;
	}

	if (
		status === 'initiaded' ||
		status === 'ringing' ||
		status === 'created'
	) {
		return isOutbound.value
			? `Ringing.`
			: 'Calling you.';
	}

	if (status === 'failed') {
		return isOutbound.value
			? `Outbound call failed.`
			: 'Inboud call failed.';
	}

	const duration = formatCallDuration();

	if (isOutbound.value) {
		return `Outbound call made by ${senderName} ${
			duration ? 'for ' + duration : ''
		}`;
	} else {
		return `Inbound call answered by ${senderName} ${
			duration ? 'for ' + duration : ''
		}`;
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: _normalizeClass(["text-13 whitespace-nowrap overflow-hidden overflow-ellipsis", 
				__props.isUnread
					? 'text-inbox-gray-theme-600 font-medium'
					: 'text-inbox-gray-theme-600 font-light'
			])
    }, _toDisplayString(getCallMessage()), 3)
  ]))
}
}

})